'use client'

import { useTranslation } from '@/hooks/client/use-translation'

export const CatalogError = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation()
  return (
    <div role="alert" className="text-navy mt-4 flex flex-wrap items-center gap-3 text-[15px]">
      <p>{t('directory.loadError', 'We couldn’t load all hearing aids. Please try again.')}</p>
      <button
        type="button"
        data-tracking="ignore"
        onClick={onRetry}
        className="border-navy/25 focus-visible:outline-lapis min-h-[44px] cursor-pointer rounded-xl border bg-white px-4 font-semibold focus-visible:outline-2 focus-visible:outline-offset-2"
      >
        {t('error.retry', 'Try again')}
      </button>
    </div>
  )
}
